/**
 * @param {number|string|null} [trait]
 * @returns {boolean}
 */
export function isDefinedTrait(trait) {
  return typeof trait === 'number' || typeof trait === 'string';
}

/**
 * @param {number|string|null} [colorId]
 * @param {number|string|null} [sizeOrTypeId]
 * @param {number|string|null} [typeId]
 * @returns {import('@composables/useUpc/types').UseUpc.UpcComplexKey}
 *
 * @example 1_1_1
 * There is no typing issue, it's js linter problem
 */
export function getComplexUpcKey(colorId, sizeOrTypeId, typeId) {
  return [colorId, sizeOrTypeId, typeId]
    .filter(isDefinedTrait)
    .join('_');
}
